const styles = {
  //coverpage
  budtenderLogoBig: {
    margin: [0, 50, 0, 5]
  },
  budtenderLogoText: {
    fontSize: 26,
    bold: true
  },
  springbigText: {
    fontSize: 16,
  },
  budtenderLogoSubText: {
    fontSize: 12,
    italics: true
  },
  coverReportTitle: {
    fontSize: 24,
    bold: true,
    margin: [0, 30, 0, 2]
  },
  coverReportDate: {
    fontSize: 20,
    bold: true,
    margin: [0, 2, 0, 2]
  },
  coverReportParams: {
    fontSize: 16,
    bold: true,
    margin: [0, 2, 0, 2]
  },
  coverStoreName: {
    fontSize: 20,
    bold: true,
    margin: [0, 2, 0, 2]
  },

  //page report header
  reportHeader: {
    fontSize: 9
  },
  header: {
    fontSize: 18,
    bold: true,
    margin: [0, 5, 0, 15]
  },
  subheader: {
    fontSize: 15,
    bold: true
  },
  feedbackHeaderTable: {
    margin: [0, 5, 0, 25]
  },
  tableHeaderSmall: {
    fontSize: 12,
    bold: false
  },
  customerName: {
    fontSize: 12
  },
  customerPhone: {
    fontSize: 11
  },
  resultsTable: {
    margin: [0, 0, 0, 0]
  },
  storeName: {
    fontsize: 12
  },
  storeLabel: {
    fontSize: 12
  },
  commentsTable: {
    margin: [0, 0, 0, 0]
  },
  comment: {
    fontSize: 10
  },
  commentNA: {
    fontSize: 9
  },
  commentLabel: {
    fontSize: 9
  },
  reportFooterTable: {
    margin: [20, 0, 20, 0],
    fontSize: 8
  },
  footerCompanyLogo: {
    margin: [0, -5, 0, 0]
  },
  footerCompanyName: {
    margin: [0, -2, 0, 0]
  },
  quote: {
    italics: true
  },
  small: {
    fontSize: 8
  }
};

export default styles;
